export var setIntervalImmediate = function setIntervalImmediate(fn, ms) {
  fn();
  return setInterval(fn, ms);
};
export var wait = function wait(ms) {
  return new Promise(function (resolve) {
    setTimeout(function () {
      resolve();
    }, ms);
  });
};